module.exports = __webpack_public_path__ + "img/HA2514-67.d79fdddb.jpg";